import {FormStepIndicator} from '../../components/form-step-indicator';
import {type FormSchema} from '../../form';
import {PageDescription} from './page-description';
import {BillingInformationSection} from './sections/billing-information-section';
import {CompanyInformationSection} from './sections/company-information-section';
import {ContactPersonInformationSection} from './sections/contact-person-information-section';
import {CompanyRegistrationFormRoot} from './company-registration-form-root';
import {TermsConsentText} from './terms-consent-text';
import {FormSubmitButton} from './form-submit-button';
import styles from './input-step.module.css';

type Props = {
  readonly defaultValues: FormSchema;
  readonly onClickConfirm: (values: FormSchema) => void;
};

export function InputStep({defaultValues, onClickConfirm}: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.overview}>
        <PageDescription />

        <FormStepIndicator step={1} />
      </div>

      <CompanyRegistrationFormRoot
        className={styles.form}
        defaultValues={defaultValues}
        submit={onClickConfirm}
      >
        <div className={styles.formSections}>
          <CompanyInformationSection />
          <ContactPersonInformationSection />
          <BillingInformationSection />
        </div>

        <TermsConsentText />

        <div className={styles.buttonContainer}>
          <FormSubmitButton />
        </div>
      </CompanyRegistrationFormRoot>
    </div>
  );
}
